import TributaAIService from "@/services/TributaAIService";

const unwrap = (promise) =>
  promise.then(
    (result) => Promise.resolve(result),
    (error) => Promise.reject(error.response?.data || error)
  );

export const tributaAI = {
  namespaced: true,
  state: {},
  actions: {
    getEmpresas: () => unwrap(TributaAIService.getEmpresas()),
    getEmpresasOData: (_, payload) =>
      unwrap(TributaAIService.getEmpresasOData(payload)),
    getEmpresasDisponiveis: () =>
      unwrap(TributaAIService.getEmpresasDisponiveis()),
    getQuantidadeProdutos: (_, id) =>
      unwrap(TributaAIService.getQuantidadeProdutos(id)),
    adicionarEmpresa: (_, payload) =>
      unwrap(TributaAIService.adicionarEmpresa(payload)),
    calcularOrcamento: (_, payload) =>
      unwrap(TributaAIService.calcularOrcamento(payload)),
    salvarContrato: (_, payload) =>
      unwrap(TributaAIService.salvarContrato(payload)),
    bloquear: (_, { id, payload }) =>
      unwrap(TributaAIService.bloquear(id, payload)),
    desbloquear: (_, { id, payload }) =>
      unwrap(TributaAIService.desbloquear(id, payload)),
    getConsumo: (_, id) => unwrap(TributaAIService.getConsumo(id)),
    getHabilitado: () => unwrap(TributaAIService.getHabilitado()),
    getSnapshotsOData: (_, payload) =>
      unwrap(TributaAIService.getSnapshotsOData(payload)),
    getSnapshots: () => unwrap(TributaAIService.getSnapshots()),
    getSnapshot: (_, { id, params }) =>
      unwrap(TributaAIService.getSnapshot(id, params)),
    getHistoricoProduto: (_, productId) =>
      unwrap(TributaAIService.getHistoricoProduto(productId)),
    removerSnapshot: (_, id) => unwrap(TributaAIService.removerSnapshot(id)),
    criarSnapshot: (_, payload) =>
      unwrap(TributaAIService.criarSnapshot(payload)),
    reconsultarSnapshot: (_, id) =>
      unwrap(TributaAIService.reconsultarSnapshot(id)),
    reconsultarItem: (_, { id, itemId }) =>
      unwrap(TributaAIService.reconsultarItem(id, itemId)),
    aplicar: (_, { id, payload }) =>
      unwrap(TributaAIService.aplicar(id, payload)),
    revisar: (_, { id, itemId, payload }) =>
      unwrap(TributaAIService.revisar(id, itemId, payload)),
  },
  mutations: {},
};

export default tributaAI;
